import { Locale } from "@/types/locale";

export const SUBDOMAIN_MAPPING = {
    staging: "https://site-staging",
    prod: "https://www",
};

export const TOP_LEVEL_DOMAIN_MAPPING: Record<Locale, string> = {
    "en-US": ".afterpay.com",
    "en-AU": ".afterpay.com",
    "en-NZ": ".afterpay.com",
    "en-CA": ".afterpay.com",
    "fr-CA": ".afterpay.com",
    "fr-FR": ".afterpay.com",
    "es-ES": ".afterpay.com",
    "it-IT": ".afterpay.com",
    "en-GB": ".clearpay.co.uk",
    global: ".afterpay.com",
};

export const generateHost = (locale: Locale) => {
    const env = process.env.NEXT_PUBLIC_AFTERPAY_ENV || "prod";
    const subdomain = SUBDOMAIN_MAPPING[env];
    const topLevelDomain = TOP_LEVEL_DOMAIN_MAPPING[locale];

    if (env === "dev") {
        return "http://localhost:8080";
    }

    return `${subdomain}${topLevelDomain}`;
};
